/**
 * ログイン中ユーザ情報
 */
export class LoginUser {
    /** ユーザID */
    userId = ""
    /** 姓 */
    lastName = ""
    /** 名 */
    firstName = ""
    /** メールアドレス */
    mail = ""
    /** 部門コード */
    departmentCode = ""
    /** 部署コード */
    sectionCode = ""
    /** 権限リスト */
    authorities: string[] = []
    /** 初回ログインフラグ */
    firstLogin = false

    /**
     * コンストラクタ
     * @param init 
     */
    constructor(init?: Partial<LoginUser>) {
        Object.assign(this, init)
    }

    /**
     * ユーザ名を取得する
     */
    get userName() {
        return this.lastName + " " + this.firstName
    }
}
